/* eslint-disable no-nested-ternary */
import * as React from 'react';
import styled from 'styled-components';
import { PrimaryButton, SecondaryButton } from '../components/ui-kit/Buttons';
import heroImg from '../assets/images/hero-illustration.svg';
import TitleSection from '../components/common/TitleSection';
import WorkInfoCard from '../components/common/WorkInfoCard';
import { BlogMainCard, BlogSimpleCard } from '../components/blog/blog';
import { projects } from '../api/project';
import { useBlogs } from '../utils/blogs';
import { useHistory } from 'react-router-dom';
import * as routes from '../routes';

const Hero = styled.main`
  .hero-wrapper {
    display: flex;
    align-items: center;
    padding-top: 180px;
    padding-bottom: 180px;
    justify-content: space-between;
    @media (max-width: 768px) {
      padding-top: 90px;
    }
  }
  .hero-content {
    flex: 1 1 43%;
    max-width: 43%;
    @media (max-width: 768px) {
      flex: 1 1 100%;
      max-width: 100%;
    }
  }
  .hero-title {
    font-size: 48px;
    color: ${(props) => props.theme.palette.text.primary};
    margin-bottom: 24px;
    line-height: 1.45;
    @media (max-width: 768px) {
      font-size: 28px;
      max-width: 300px;
    }
  }
  .hero-description {
    color: ${(props) => props.theme.palette.text.secondary};
    margin-bottom: 50px;
    line-height: 1.51;
  }
  .hero-wrapperBtn {
    button + button {
      margin-left: 26px;
      @media (max-width: 768px) {
        margin-left: 0;
        margin-top: 20px;
      }
    }
    @media (max-width: 768px) {
      display: flex;
      flex-direction: column;
    }
  }
  .hero-img {
    margin-top: 120px;
    align-self: flex-end;
    @media (max-width: 768px) {
      display: none;
    }
  }
`;
function HeroSection() {
  const history = useHistory();
  return (
    <Hero>
      <div className="hero-wrapper">
        <div className="hero-content">
          <h1 className="hero-title">Creating Unique Digital Experiences.</h1>
          <p className="hero-description">
            I’m passionate about building quality products that people enjoy, and solving real-world
            problems. Love learning and sharing content to give back to the community.
          </p>
          <div className="hero-wrapperBtn">
            <PrimaryButton>
              <a href="mailto:paulclindo@gmail.com" target="_blank" rel="noreferrer">
                Get In Touch
              </a>
            </PrimaryButton>
            <SecondaryButton onClick={() => history.push(routes.about)}>
              Get To Know Me
            </SecondaryButton>
          </div>
        </div>
        <div className="hero-img">
          <img src={heroImg} alt="" />
        </div>
      </div>
    </Hero>
  );
}

const Work = styled.div`
  margin-top: 40px;
  margin-bottom: 60px;
`;
export const WorkListCard = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
export const WrapperButton = styled.div`
  display: flex;
  margin-top: 60px;
  justify-content: center;
  @media (max-width: 768px) {
    margin-top: 20px;
  }
`;

function LatestWorkSection() {
  const history = useHistory();
  return (
    <Work>
      <TitleSection title="Latest Work" caption="A simple, secure and fast Cardano ADA" />
      <WorkListCard>
        {projects.slice(0, 2).map((item) => (
          <WorkInfoCard id={item.id} {...item} />
        ))}
      </WorkListCard>
      <WrapperButton>
        <SecondaryButton onClick={() => history.push(routes.work)}>See More</SecondaryButton>
      </WrapperButton>
    </Work>
  );
}

const BlogSection = styled.div`
  margin-top: 100px;
  margin-bottom: 60px;
`;
const BlogMainList = styled.div`
  display: grid;
  grid-template-columns: 1.1fr 1fr;
  grid-template-rows: auto auto auto auto auto auto;
  grid-gap: 16px;
  margin: 40px 0;
  @media (max-width: 768px) {
    display: block;
  }
`;

function BlogHome() {
  const { isLoading, isError, isSuccess, blogs } = useBlogs();
  const mainBlog = isSuccess && blogs.length && blogs[0];
  const secondaryBlogs = isSuccess && blogs.length && blogs.slice(1, 4);

  return (
    <BlogSection>
      <TitleSection align="center" title="Recent Blogs & Updates" caption="Stay tuned" />
      <BlogMainList>
        {isError ? <p>error</p> : null}
        {isLoading ? (
          'Loading...'
        ) : isSuccess && blogs.length ? (
          <>
            <BlogMainCard
              slug={mainBlog.fields.slug}
              category={mainBlog.fields.category}
              title={mainBlog.fields.title}
              shortDescription={mainBlog.fields.summary}
              image={mainBlog.fields.cover_image.fields.file.url}
              author={mainBlog.fields.author}
              avatar={mainBlog.fields.authorAvatar.fields.file.url}
            />
            {secondaryBlogs.map((blog) => (
              <BlogSimpleCard
                slug={blog.fields.slug}
                title={blog.fields.title}
                description={blog.fields.summary}
                category={blog.fields.category}
                image={blog.fields.cover_image.fields.file.url}
                imageAlt={blog.fields.cover_image.fields.file.title}
              />
            ))}
          </>
        ) : isSuccess && blogs.length ? (
          <p>There&apos;s no blog yet. Coming soon..</p>
        ) : null}
      </BlogMainList>
    </BlogSection>
  );
}

function HomePage() {
  return (
    <>
      <HeroSection />
      <LatestWorkSection />
      <BlogHome />
    </>
  );
}

export default HomePage;
